import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as moment from 'moment';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-users',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  userData: any = {};

  admissionform: any[] = [];
  paymentDetails: any[] = [];

  // Show More / Show Less controls
  admissionLimit = 5;
  invoiceLimit = 5;

  showAllAdmissions = false;
  showAllInvoices = false;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService
  ) {}

  ngOnInit(): void {
    this.loadUserData();
    this.getAdmissionForms();
    this.getPaymentDetails();
  }

  loadUserData() {
    let raw = localStorage.getItem('studentDetails');
    if (!raw) return;

    try {
      let parsed = JSON.parse(raw);
      if (typeof parsed === 'string') parsed = JSON.parse(parsed);

      this.userData = parsed;

      if (this.userData.dob) {
        this.userData.dateOfBirth = moment(this.userData.dob).format(
          'DD-MM-YYYY'
        );
      }

      if (!this.userData.image) {
        this.userData.image = 'assets/tenant-avatar.png';
      }
    } catch (e) {
      this.userData = {};
    }
  }

  /** -------------------- ADMISSION FORMS -------------------- **/
  getAdmissionForms() {
    this.commonservice
      .getMethod(`newuseradmissionform?user_id=${this.userData.id}`, '')
      .then((resp: any) => {
        if (resp?.status_code === '200' && Array.isArray(resp.data)) {
          this.admissionform = resp.data.map((a) => ({
            ...a,
            image: a.image || 'assets/avatar.png',
          }));
        } else {
          this.admissionform = [];
        }
      })
      .catch(() => {
        this.admissionform = [];
      });
  }

  get limitedAdmissionForms() {
    return this.showAllAdmissions
      ? this.admissionform
      : this.admissionform.slice(0, this.admissionLimit);
  }

  toggleAdmissionView() {
    this.showAllAdmissions = !this.showAllAdmissions;
  }

  downloadForm(a: any) {
    window.open(
      `https://smscap.in/api/downloadnewuseradmissionform?user_id=${a.user_id}&id=${a.id}`
    );
  }

  /** -------------------- INVOICES -------------------- **/
  async getPaymentDetails() {
    let service = this.utils.getApiConfigs('payment')[0];

    let resp: any = await this.commonservice.invokeService(
      service.method,
      `${service.path}?user_id=${this.userData.id}&payment_status=Success`,
      null
    );

    if (resp?.status_code === '404') {
      this.paymentDetails = [];
      return;
    }

    if (Array.isArray(resp?.data)) {
      this.paymentDetails = resp.data.map((p: any) => ({
        ...p,
        paid_date: moment(p.paid_date).format('DD-MM-YYYY HH:mm:ss'),
      }));
    } else {
      this.paymentDetails = [];
    }
  }

  get limitedInvoices() {
    return this.showAllInvoices
      ? this.paymentDetails
      : this.paymentDetails.slice(0, this.invoiceLimit);
  }

  toggleInvoiceView() {
    this.showAllInvoices = !this.showAllInvoices;
  }

  downloadInvoice(p: any) {
    if (p?.receipt_id)
      window.open(
        `https://smscap.in/api/downloadinvoice?receipt_id=${p.receipt_id}`
      );
  }

  onImageError(event: any) {
    event.target.src = 'assets/avatar.png';
  }
}
